export const getPayloadSize = (payload) => {
    const payloadString = JSON.stringify(payload);
    return new Blob([payloadString]).size;
  };
  
  export const payloadQualifiesForS3Upload = (size) => size > 128000;


  